import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=541df38e&scoped=true"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=541df38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541df38e",
  null
  
)

export default component.exports